// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C0W0w","colMin":"styles_colMin__1Crre"};